var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.proBusinesses)?_c('section',[_c('businesses-map',{attrs:{"businesses":_vm.proBusinesses,"zoom":6,"custom-map-center":_vm.FRANCE_COORDS,"hide-user-location-marker":"","tall":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }